import React, { useState ,useEffect} from "react";
import {
  BackArrowButton,
  CancelButton,
  ContinueButton,
  CloseButton,
} from "../../button/Button";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import swal from "sweetalert";
import styles from "./ColumnMapping.module.css";
import commonstyles from "../Forms.module.css";
import { getFixedAssetMapping } from "../../../../Bookclosure/Services/ApiHandler";
import {updateFixedAssetMapping} from "../../../../Bookclosure/Services/ApiHandler";
const LABEL_FIELDS = [
  "Asset ID",
  "Asset Description",
  "Block Of Asset",
  "Asset Location",
  "Business Area",
  "Capitalised On",
  "Deactivated On",
  "Opening Gross Block",
  "Acquisition Cost For CY Additions",
  "Gross Book Value Of Deletion",
  "Opening Accumulated Depreciation",
  "Depreciation Rate",
  "Depreciation Charge For The Period",
  "Deletion Depreciation",
  "Closing Gross Block",
  "Closing Accumulated Depreciation",
  "Opening Net Book Value",
  "Closing Net Book Value",
  "Sale Proceeds"
];

// const LABEL_FIELDS = [
//    "Supplier ID",
//   "Supplier Name",
//    "Doc Date",
//    "Due Days",
//    "Due Date",
//    "Foreign Currency",
//    "Exchange Currency Value",
//    "GL Account Code",
//    "Business",
//    "Business Person Responsible",
//    "Provision",
//    "Category",
//  ];

const REQUIRED_FIELDS = [
  "Asset ID",
  "Asset Description",
  "Block Of Asset",
  "Capitalised On",
  "Deactivated On",
  "Opening Gross Block",
  "Opening Accumulated Depreciation"
];

const KEY_FIELDS = [
  "assetID",
  "assetDescription",
  "blockOfAsset",
  "assetLocation",
  "businessArea",
  "capitalisedOn",
  "deactivatedOn",
  "openingGrossBlock",
  "acquisitionCostForCYAdditions",
  "grossBookValueOfDeletion",
  "openingAccumulatedDepreciation",
  "depreciationRate",
  "depreciationChargeForThePeriod",
  "deletionDepreciation",
  "closingGrossBlock",
  "closingAccumulatedDepreciation",
  "openingNetBookValue",
  "closingNetBookValue",
  "saleProceeds"
];

const LABEL_TO_KEY = {
  "Asset ID": "assetID",
  "Asset Description": "assetDescription",
  "Block Of Asset": "blockOfAsset",
  "Asset Location": "assetLocation",
  "Business Area": "businessArea",
  "Capitalised On": "capitalisedOn",
  "Deactivated On": "deactivatedOn",
  "Opening Gross Block": "openingGrossBlock",
  "Acquisition Cost For CY Additions": "acquisitionCostForCYAdditions",
  "Gross Book Value Of Deletion": "grossBookValueOfDeletion",
  "Opening Accumulated Depreciation": "openingAccumulatedDepreciation",
  "Depreciation Rate": "depreciationRate",
  "Depreciation Charge For The Period": "depreciationChargeForThePeriod",
  "Deletion Depreciation": "deletionDepreciation",
  "Closing Gross Block": "closingGrossBlock",
  "Closing Accumulated Depreciation": "closingAccumulatedDepreciation",
  "Opening Net Book Value": "openingNetBookValue",
  "Closing Net Book Value": "closingNetBookValue",
  "Sale Proceeds": "saleProceeds"
};

const DEFAULT_MAPPING = {
  assetID: "Asset ID",
  assetDescription: "Asset Description",
  blockOfAsset: "Block Of Asset",
  assetLocation: "Asset Location",
  businessArea: "Business Area",
  capitalisedOn: "Capitalised On",
  deactivatedOn: "Deactivated On",
  openingGrossBlock: "Opening Gross Block",
  acquisitionCostForCYAdditions: "Acquisition Cost For CY Additions",
  grossBookValueOfDeletion: "Gross Book Value Of Deletion",
  openingAccumulatedDepreciation: "Opening Accumulated Depreciation",
  depreciationRate: "Depreciation Rate",
  depreciationChargeForThePeriod: "Depreciation Charge For The Period",
  deletionDepreciation: "Deletion Depreciation",
  closingGrossBlock: "Closing Gross Block",
  closingAccumulatedDepreciation: "Closing Accumulated Depreciation",
  openingNetBookValue: "Opening Net Book Value",
  closingNetBookValue: "Closing Net Book Value",
  saleProceeds: "Sale Proceeds"
};

const ColumnMapping = ({
  FixedAssetID,
  onContinue,
  onBack,
  onCancel,
  onClose,
}) => {
 const [columnOptions, setColumnOptions] = useState([]);
 
   const [mappedValues, setMappedValues] = useState(
     KEY_FIELDS.reduce((acc, key) => ({ ...acc, [key]: "" }), {})
   );
 
   const [loading, setLoading] = useState(true);
   const [apiError, setApiError] = useState(null);
 
   useEffect(() => {
     const fetchMapping = async () => {
       setLoading(true);
       setApiError(null);
 
       try {
         const response = await getFixedAssetMapping(FixedAssetID);
         const fields = response?.data?.fields || [];
 
         setColumnOptions(fields);
 
         const autoMapped = {};
         KEY_FIELDS.forEach((key) => {
           const defaultValue = DEFAULT_MAPPING[key];
           if (fields.includes(defaultValue)) {
             autoMapped[key] = defaultValue;
           }
         });
 
        setMappedValues((prev) => {
          const hasAnyValue =
            prev && Object.values(prev).some((value) => value && value !== "");

          if (hasAnyValue) {
            return prev; 
          }

          return { ...prev, ...autoMapped }; 
        });
       } catch (error) {
         console.error("Error fetching sale mapping:", error);
         setApiError("Failed to load");
       }
 
       setLoading(false);
     };
 
     fetchMapping();
   }, [FixedAssetID]);
 
   const handleFieldChange = (label, value) => {
     const key = LABEL_TO_KEY[label];
     setMappedValues((prev) => ({ ...prev, [key]: value }));
   };
 
  const fieldsMapped = REQUIRED_FIELDS.every(
      (label) => {
        const key = LABEL_TO_KEY[label];
        return mappedValues[key] && mappedValues[key] !== "";
      }
    );
    
   const handleSubmit = async () => {
     if (!fieldsMapped) return;
 
     try {
       setLoading(true);
       await updateFixedAssetMapping(FixedAssetID, mappedValues);
       onContinue();
     } catch (error) {
      console.error("Error updating sale mapping:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to Update Mapping.";

      swal("Error", errorMessage, "error");
    }
     setLoading(false);
   };

  return (
    <div className={commonstyles.backdrop}>
      <div
        className={`${commonstyles.container} ${commonstyles.largeContainer}`}
      >
        <header className={commonstyles.header}>
          <div className={commonstyles.headerLeft}>
            <span>
              <BackArrowButton onClick={onBack} />
            </span>
            <h2 className={commonstyles.heading}>Map Column Headers</h2>
          </div>
          <CloseButton onClick={onClose} />
        </header>

        <form className={styles.gridForm}>
          {LABEL_FIELDS.map((label) => (
            <CustomDropdown
              key={label}
              label={label}
              value={mappedValues[LABEL_TO_KEY[label]] || ""}
              onChange={(value) => handleFieldChange(label, value)}
              options={columnOptions}
              placeholder="Select Column"
              required={REQUIRED_FIELDS.includes(label)} 
            />
          ))} 
        </form>

        <div className={commonstyles.footer}>
          <CancelButton onClick={onCancel} />
          <ContinueButton onClick={handleSubmit}
          disabled={!fieldsMapped || loading || apiError} />
        </div>
      </div>
    </div>
  );
};

export default ColumnMapping;
